import {add, minus, podiliti} from "./js/calculator"


console.log(minus(15,2));
console.log(add(233,23033));
console.log(podiliti(6,2));


